import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=15d2a5cc&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=ts&"
export * from "./Overview.vue?vue&type=script&lang=ts&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=15d2a5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2a5cc",
  null
  
)

/* custom blocks */
import block0 from "./Overview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports